function initDownloadAccordion() {
	const triggers = document.querySelectorAll('.item-download__trigger');

	if (!triggers.length) return;

	triggers.forEach(trigger => {
		trigger.addEventListener('click', function () {
			const item = this.closest('.item-download');
			if (!item) return;

			const isOpen = item.classList.contains('item-download--active');

			// document.querySelectorAll('.item-download.item-download--active').forEach(item => item.classList.remove('item-download--active'));

			// if (!isOpen) item.classList.add('item-download--active')
			document.querySelectorAll('.item-download.item-download--active').forEach(openItem => {
				openItem.classList.remove('item-download--active');
				const content = openItem.querySelector('.item-download__content');
				if (content) content.style.maxHeight = '';
			});

			if (!isOpen) {
				item.classList.add('item-download--active');
				const content = item.querySelector('.item-download__content');
				if (content) content.style.maxHeight = content.scrollHeight + 200 + 'px';
			}
		});
	});
}

function initGallerySwipers() {
	const gallerySections = document.querySelectorAll('.gallery');

	if (!gallerySections.length) return;
	if (typeof Swiper === 'undefined') return;

	gallerySections.forEach(section => {
		const swiperEl = section.querySelector('.swiper-gallery');
		if (!swiperEl) return;

		const prevBtn = section.querySelector('.gallery__arrow--left');
		const nextBtn = section.querySelector('.gallery__arrow--right');
		new Swiper(swiperEl, {
			slidesPerView: 1.1,
			spaceBetween: 16,
			grabCursor: true,
			loop: true,
			autoHeight: true,
			navigation: {
				prevEl: prevBtn,
				nextEl: nextBtn,
			},
			breakpoints: {
				640: {
					spaceBetween: 32,
				},
				991: {
					slidesPerView: 1,
					spaceBetween: 64,
				},
			},

		});
	});
}

window.addEventListener('load', () => {
	initDownloadAccordion();
	initGallerySwipers();
});